export enum ECouponStatus {
  ACTIVE = 'ACTIVE',
  BURNED = 'BURNED',
  EXPIRED = 'EXPIRED',
}
